import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../themes/base/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_onesignal_5e175204 from 'nuxt_plugin_onesignal_5e175204' // Source: ./onesignal.js (mode: 'client')
import nuxt_plugin_libplugin6b98ab44_adec9f24 from 'nuxt_plugin_libplugin6b98ab44_adec9f24' // Source: ./lib.plugin.6b98ab44.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_090f403e from 'nuxt_plugin_cookieuniversalnuxt_090f403e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_workbox_23c53432 from 'nuxt_plugin_workbox_23c53432' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_2c082945 from 'nuxt_plugin_metaplugin_2c082945' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_30afceb9 from 'nuxt_plugin_iconplugin_30afceb9' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_55258c96 from 'nuxt_plugin_axios_55258c96' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_apollomodule_6d953b3c from 'nuxt_plugin_apollomodule_6d953b3c' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_nuxtplugin44ca172c_42842c06 from 'nuxt_plugin_nuxtplugin44ca172c_42842c06' // Source: ./nuxt.plugin.44ca172c.js (mode: 'all')
import nuxt_plugin_i18n_5858845e from 'nuxt_plugin_i18n_5858845e' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_globalcomponents_9f817a82 from 'nuxt_plugin_globalcomponents_9f817a82' // Source: ../plugins/global-components.js (mode: 'all')
import nuxt_plugin_globalfilters_623a393e from 'nuxt_plugin_globalfilters_623a393e' // Source: ../plugins/global-filters.js (mode: 'all')
import nuxt_plugin_polyfillclient_28f034b5 from 'nuxt_plugin_polyfillclient_28f034b5' // Source: ../plugins/polyfill.client.js (mode: 'client')
import nuxt_plugin_initializegdpr_6c00be36 from 'nuxt_plugin_initializegdpr_6c00be36' // Source: ../themes/base/plugins/initialize-gdpr.ts (mode: 'client')
import nuxt_plugin_ssofilters_950edb9e from 'nuxt_plugin_ssofilters_950edb9e' // Source: ../themes/neue/plugins/sso-filters.js (mode: 'all')
import nuxt_plugin_initializeapp_9ac6ce56 from 'nuxt_plugin_initializeapp_9ac6ce56' // Source: ../themes/base/plugins/initialize-app.ts (mode: 'client')
import nuxt_plugin_piano_785edcf8 from 'nuxt_plugin_piano_785edcf8' // Source: ../themes/neue/plugins/piano.js (mode: 'client')
import nuxt_plugin_components_d908d0a6 from 'nuxt_plugin_components_d908d0a6' // Source: ../themes/base/plugins/components.js (mode: 'all')
import nuxt_plugin_components_4e0136ac from 'nuxt_plugin_components_4e0136ac' // Source: ../themes/neue/plugins/components.js (mode: 'all')
import nuxt_plugin_sidebar_1904af9c from 'nuxt_plugin_sidebar_1904af9c' // Source: ../themes/neue/plugins/sidebar.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"NEUE Vorarlberger Tageszeitung | NEUE.at","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":undefined},{"name":"theme-color","content":"#0067AB"},{"hid":"robots","name":"robots","content":"index,follow"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"preconnect","href":"https:\u002F\u002Fsessions.bugsnag.com"},{"rel":"preconnect","href":"https:\u002F\u002Fsandbox.tinypass.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fwww.vol.at"},{"rel":"preconnect","href":undefined},{"rel":"dns-prefetch","href":undefined}],"__dangerouslyDisableSanitizers":["script"],"script":[{"type":"application\u002Fld+json","innerHTML":"{\"@context\":\"http:\u002F\u002Fschema.org\",\"@type\":\"Corporation\",\"name\":\"NEUE Vorarlberger Tageszeitung\",\"legalName\":\"NEUE Zeitungs GmbH\",\"address\":{\"@type\":\"PostalAddress\",\"addressCountry\":\"AT\",\"addressLocality\":\"Schwarzach\",\"addressRegion\":\"Vorarlberg\",\"postalCode\":\"6858\",\"streetAddress\":\"Gutenbergstrasse 1\"},\"logo\":\"https:\u002F\u002Fwww.neue.at\u002Ficon.png\",\"email\":\"mailto:abo@neue.at\",\"telephone\":\"+435572501500\",\"url\":\"https:\u002F\u002Fwww.neue.at\"}"},{"async":true,"src":"\u002Fos-sdk.js","hid":"onesignal"}],"noscript":[],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_onesignal_5e175204 === 'function') {
    await nuxt_plugin_onesignal_5e175204(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin6b98ab44_adec9f24 === 'function') {
    await nuxt_plugin_libplugin6b98ab44_adec9f24(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_090f403e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_090f403e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_23c53432 === 'function') {
    await nuxt_plugin_workbox_23c53432(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_2c082945 === 'function') {
    await nuxt_plugin_metaplugin_2c082945(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_30afceb9 === 'function') {
    await nuxt_plugin_iconplugin_30afceb9(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_55258c96 === 'function') {
    await nuxt_plugin_axios_55258c96(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_6d953b3c === 'function') {
    await nuxt_plugin_apollomodule_6d953b3c(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin44ca172c_42842c06 === 'function') {
    await nuxt_plugin_nuxtplugin44ca172c_42842c06(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_5858845e === 'function') {
    await nuxt_plugin_i18n_5858845e(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_9f817a82 === 'function') {
    await nuxt_plugin_globalcomponents_9f817a82(app.context, inject)
  }

  if (typeof nuxt_plugin_globalfilters_623a393e === 'function') {
    await nuxt_plugin_globalfilters_623a393e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfillclient_28f034b5 === 'function') {
    await nuxt_plugin_polyfillclient_28f034b5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initializegdpr_6c00be36 === 'function') {
    await nuxt_plugin_initializegdpr_6c00be36(app.context, inject)
  }

  if (typeof nuxt_plugin_ssofilters_950edb9e === 'function') {
    await nuxt_plugin_ssofilters_950edb9e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initializeapp_9ac6ce56 === 'function') {
    await nuxt_plugin_initializeapp_9ac6ce56(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_piano_785edcf8 === 'function') {
    await nuxt_plugin_piano_785edcf8(app.context, inject)
  }

  if (typeof nuxt_plugin_components_d908d0a6 === 'function') {
    await nuxt_plugin_components_d908d0a6(app.context, inject)
  }

  if (typeof nuxt_plugin_components_4e0136ac === 'function') {
    await nuxt_plugin_components_4e0136ac(app.context, inject)
  }

  if (typeof nuxt_plugin_sidebar_1904af9c === 'function') {
    await nuxt_plugin_sidebar_1904af9c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
